import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { SmartCohortCardDto } from '../../../models/churn-prediction/dto/churn-prediction.dto';

export const GET_SMART_COHORTS_QUERY_KEY = (organizationId: string) => [
  'smart-cohorts',
  organizationId,
];

export function useGetSmartCohorts(organizationId?: string) {
  const apiClient = useApiClient();

  return useQuery<SmartCohortCardDto[]>({
    enabled: Boolean(organizationId),
    queryKey: GET_SMART_COHORTS_QUERY_KEY(organizationId!),
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<SmartCohortCardDto[]> => {
      const response = await apiClient.fetchApi<SmartCohortCardDto[], {}>({
        method: 'GET',
        endpoint: `churn-prediction/admin/${organizationId}/smart-cohorts`,
      });
      return response;
    },
  });
}
